import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { Tooltip } from '@material-ui/core';

const AddMemberTrigger = ({ showAddMembers, classes }) => {
    return (
        <Paper square elevation={1} className={classes.wrapper}>
            <div onClick={showAddMembers} className={classes.holder}>
                <Tooltip title="Invite people">
                    <IconButton className={classes.button}>
                        <i className="material-icons">person_add</i>
                    </IconButton>
                </Tooltip>
                <span>Add member</span>
            </div>
        </Paper>
    );
};

AddMemberTrigger.propTypes = {
    showAddMembers: PropTypes.func.isRequired,
};

const style = ({ palette, spacing }) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginTop: spacing.unit * 3,
        color: palette.text.secondary,
        '&:hover': {
            backgroundColor: palette.background.gray1Color,
        },
    },
    holder: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        cursor: 'pointer',
        maxWidth: spacing.maxWidth,
        width: '100%',
    },
    button: {
        marginLeft: spacing.unit * 2,
        marginRight: spacing.unit,
    },
});

export default injectSheet(style)(AddMemberTrigger);



// WEBPACK FOOTER //
// ./src/components/addMember/AddMemberTrigger.js